<template>
    <router-view />
</template>
<script>
export default {
    name: 'AgendaRoute',

    beforeRouteUpdate(to, from, next) {
        if (to.name == 'crm-agenda') {
            next({ name: 'crm-agenda-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'crm-agenda') {
            this.$router.push({ name: 'crm-agenda-list' });
        }
    },
};
</script>
